import React from 'react'
// import Testimonails from './fronend/Testimonials';

const Home = () => {
    return (
    
    <>
   <section className='midwrap' id='aboutus'>
        <div className='container w-80'>
           <div className='row align-items-start'>
            <div className='col-md-6'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='leftbox'>
                            <div className='l-box1'>
                            <img src="\images\leftImg.jpg" alt=""/>
                            <h3>Dashboard</h3>
                            <p>Bring a data driven approach to your case coverage with interactive, time series dashboards</p>
                            </div>
                            <div className='l-box1'>
                            <img src="\images\leftImg.jpg" alt=""/>
                            <h3>Live Calendar</h3>
                            <p>Maintain a complete view of procedure descriptions</p>
                            </div>
                        </div>

                    </div>
                    <div className='col-md-6'>
                    <div className='rightbox'>
                        <div className='r-box1'>
                        <img src="\images\leftImg.jpg" alt=""/>
                        <h3>Physician Search</h3>
                            <p>Consolidate your surgical schedules in a single centralized view</p>
                        </div>
                        <div className='r-box1'>
                        <img src="\images\leftImg.jpg" alt=""/>
                        <h3>Real-time Notifications</h3>
                            <p>Never miss another case addition or cancellation</p>
                            <img src="\images\dotstrip.png" className="aboutstrip" alt=""/>
                        </div>
                    </div>
                 
                    </div>
                </div>
            </div>
                <div className='col-md-6'>
                   <div className='aboutright'>
                        <h2>Our Solution</h2>
                        <p>Every surgical practice is a complex ecosystem. Replinq bridges the gap between medical personnel and vendors, removing human error and enabling a higher standard of care.</p>
                        <ul className="list-group aboulist">
                        
                            <li>Consolidate your entire surgical schedule in one, centralized view</li>
                            <li>Automate case notifications, additions, changes</li>
                            <li>Eliminate human error and miscommunications that may lead to cancellations or delays</li>
                        </ul>
                        <div style={{textAlign: 'center', marginTop: '2rem'}}>
                            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#ModalRegistration">Join the Waitlist</button>
                        </div>
                    </div>
                </div>  
              
            </div>
        </div>

        {/* <Testimonails /> */}
           
    </section>
    </>
    

    )
  };
  
  export default Home;
  